export default function GrandOpening() {
  return (
    <section className="py-20 bg-[#1A0A0A] relative overflow-hidden">
      {/* 背景装饰 */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C0392B]/60 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C0392B]/60 to-transparent"></div>
        <div className="absolute -left-20 top-1/2 -translate-y-1/2 w-80 h-80 rounded-full bg-[#C0392B]/5 blur-3xl"></div>
        <div className="absolute -right-20 top-1/2 -translate-y-1/2 w-80 h-80 rounded-full bg-[#C0392B]/5 blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center">
        {/* 主标题 */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-white leading-tight mb-6 tracking-wide">
          Grand Opening
        </h2>

        {/* 日期 */}
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="w-16 h-px bg-white/20"></div>
          <p className="text-xl md:text-2xl text-[#E8C4A0] tracking-[0.2em] font-light">
            1 June 2026
          </p>
          <div className="w-16 h-px bg-white/20"></div>
        </div>
      </div>
    </section>
  );
}
